import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import { AiOutlineClose } from 'react-icons/ai'
import { FaBars } from 'react-icons/fa'

export default function Header() {
  const [showSidebar, setShowSidebar] = useState(false)

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar)
  }

  const navLinks = [
    { name: 'Home', path: '/categories/d553aee5-b0f0-44f5-a187-25c212b4b454' },
    { name: 'About Us', path: '/about' },
    { name: 'Terms & Conditions', path: '/terms' }
  ]

  return (
    <>
      {/* Main Header */}
      <header className="sticky top-0 z-50 bg-gradient-primary/90 backdrop-blur-md shadow-lg">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          {/* Logo */}
          <Link to="/">
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="flex items-center"
            >
              <img
                src="https://www.ghanastudentsmostbeautiful.com/wp-content/uploads/2023/12/LOGO.png"
                alt="Logo"
                className="h-12 w-auto"
              />
            </motion.div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link key={link.path} to={link.path}>
                <motion.div
                  className="relative group text-white font-semibold text-sm uppercase tracking-wide"
                  whileHover={{ y: -2 }}
                >
                  {link.name}
                  {/* Gradient underline on hover */}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-cta-hover group-hover:w-full transition-all duration-300"></span>
                </motion.div>
              </Link>
            ))}
          </nav>

          {/* Mobile Hamburger */}
          <motion.button
            whileTap={{ scale: 0.95 }}
            onClick={toggleSidebar}
            className="md:hidden text-white text-2xl p-2"
            aria-label="Toggle menu"
          >
            <FaBars />
          </motion.button>
        </div>
      </header>

      {/* Mobile Sidebar */}
      <AnimatePresence>
        {showSidebar && (
          <>
            {/* Backdrop */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={toggleSidebar}
              className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[60] md:hidden"
            />

            {/* Sidebar */}
            <motion.div
              initial={{ x: '100%' }}
              animate={{ x: 0 }}
              exit={{ x: '100%' }}
              transition={{ type: 'spring', damping: 25, stiffness: 200 }}
              className="fixed inset-y-0 right-0 w-64 bg-gradient-royal shadow-glow-purple z-[70] md:hidden"
            >
              {/* Close button */}
              <div className="flex justify-end p-6">
                <motion.button
                  whileTap={{ scale: 0.9 }}
                  onClick={toggleSidebar}
                  className="text-white text-2xl p-2"
                  aria-label="Close menu"
                >
                  <AiOutlineClose />
                </motion.button>
              </div>

              {/* Navigation links */}
              <nav className="flex flex-col gap-6 px-6">
                {navLinks.map((link, index) => (
                  <Link key={link.path} to={link.path} onClick={toggleSidebar}>
                    <motion.div
                      initial={{ opacity: 0, x: 20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: index * 0.1 }}
                      className="text-white font-semibold text-lg py-3 px-4 rounded-lg hover:bg-white/10 transition-colors"
                    >
                      {link.name}
                    </motion.div>
                  </Link>
                ))}
              </nav>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  )
}
